module.exports = __webpack_public_path__ + "media/images/logo-mercy-w-d2d8d2400086c3130286ba28d666b66d.png";